(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stockCorrection', {
        templateUrl: 'views/components/views/stockCorrection/stockCorrection.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: [
            '$stateParams',
            'stateService',
            'utilityService',
            'stockCorrectionService',
            'logisticService',
            function ($stateParams, stateService, utilityService, stockCorrectionService, logisticService) {
                // #region VARIABLES & DEFINITIONS

                const vm = this;
                let stockKeyno = $stateParams.stock_keyno;
                let stockLocationKeyno = $stateParams.stocklocation_keyno;

                vm.model = {
                    volumeM3Buttons: [{ id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('prodsizeedit', { prodsize_keyno: vm.model.edit.prodsize_keyno }) }],
                    eanListButtons: [{ id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('producteans', { prod_id: vm.model.edit.prod_keyno }) }],
                    edit: {},
                    selectListCodes: [],
                    lockedSave: false,
                };

                // #endregion VARIABLES & DEFINITIONS

                // #region LOAD PROCEDURE CALLS

                async function loadEdit() {
                    vm.model.edit = (
                        await stockCorrectionService.getEdit({
                            stock_keyno: stockKeyno,
                            stocklocation_keyno: stockLocationKeyno,
                        })
                    )[0];
                }

                async function loadStockCorrectionCodes() {
                    vm.model.selectListCodes = await logisticService.listStockCorrectionCodes();
                }

                // #endregion LOAD PROCEDURE CALLS

                // #region CALCULATE FUNCTIONS

                function calcStockStockValue() {
                    vm.model.edit.stock_stockvalue_change = utilityService.parseNumber(vm.model.edit.stock_stockvalue_new) - utilityService.parseNumber(vm.model.edit.stock_stockvalue_old);
                }

                function calcStockValueNew() {
                    //stock_stockvalue_new = stock_on_shelf_new + stockbatch_qty_assigned
                    vm.model.edit.stock_stockvalue_new = utilityService.parseNumber(vm.model.edit.stock_onshelf_new) + utilityService.parseNumber(vm.model.edit.stockbatch_qty_assigned);
                }

                // #endregion CALCULATE FUNCTIONS

                // #region MULTI DIRECTION BUTTON FUNCTIONS

                vm.goToFunc = function (state, e) {
                    function go(parms) {
                        if (e?.ctrlKey) {
                            stateService.newTab(state, parms);
                        } else {
                            stateService.go(state, parms);
                        }
                    }

                    switch (state) {
                        case 'picturebanks':
                            go({
                                argtype: 'stock_keyno',
                                argvalue: vm.model.edit.stock_keyno,
                            });
                            break;
                        default:
                            break;
                    }
                };

                // #endregion MULTI DIRECTION BUTTON FUNCTIONS

                // #region BUTTON SAVE PROCEDURE FUNCTION CALL

                vm.saveChanges = function () {
                    vm.model.lockedSave = true;

                    stockCorrectionService.saveObj(vm.model.edit).then(
                        () => {
                            const searchParams = new URL(window.location.href.replaceAll('#', '')).searchParams;

                            if (searchParams.get('ispopup') !== null) {
                                window.close();
                            } else {
                                vm.model.lockedSave = false;
                                stateService.back();
                            }
                        },
                        () => (vm.model.lockedSave = false)
                    );
                };

                // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

                // #region FIELD CHANGE MULTI FUNCTIONS

                vm.onChanged = function (value, id) {
                    switch (id) {
                        case 'stock_onshelf_new':
                            if (utilityService.validateWatchValue(value, vm.model.edit.stock_onshelf_new) !== true) return;

                            vm.model.edit.stock_onshelf_new = value;

                            if (utilityService.validateParmsValue(vm.model.edit.stock_onshelf_new, true) !== true) return;

                            calcStockValueNew();
                            break;
                        case 'stock_stockvalue_new':
                            if (utilityService.validateWatchValue(value, vm.model.edit.stock_stockvalue_new) !== true) return;

                            vm.model.edit.stock_stockvalue_new = value;

                            if (utilityService.validateParmsValue(vm.model.edit.stock_stockvalue_new, true) !== true) return;

                            calcStockStockValue();
                            break;
                        default:
                            utilityService.setValueToVariable(value);
                            break;
                    }
                };

                // #endregion FIELD CHANGE MULTI FUNCTIONS

                // #region ON INIT FUNCTION

                vm.$onInit = function () {
                    loadEdit();
                    loadStockCorrectionCodes();
                };

                // #endregion ON INIT FUNCTION
            },
        ],
    });
})();
